(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lunere-landing"] && !Shopify.designMode) return;
  try {
    
(()=>{const root=document.querySelector('#lunere-landing');if(!root)return;const menu=root.querySelector('.menu-toggle');
const vsl=root.querySelector('#lunere-vsl');
const vslFrame=root.querySelector('.vsl-player');
const vslStart=root.querySelector('.vsl-start');
document.addEventListener('play',event=>{
 if(event.target instanceof HTMLVideoElement)root.querySelectorAll('video').forEach(video=>{if(video!==event.target)video.pause()});
},true);
root.querySelector('.watch-first').addEventListener('click',()=>{vslStart.click();vslFrame.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'})});
vsl.muted=true;
vsl.play().catch(()=>{}); 
vslStart.addEventListener('click',()=>{
 vsl.currentTime=0;
 vsl.muted=false;
 vsl.volume=1;
 vsl.loop=false;
 vsl.play().then(()=>{vslFrame.classList.add('has-sound')}).catch(()=>{vslFrame.classList.remove('has-sound')});
});
vsl.addEventListener('volumechange',()=>{if(!vsl.muted)vslFrame.classList.add('has-sound')});
vsl.addEventListener('error',()=>{root.querySelector('.vsl-error').hidden=false});
const mobile=root.querySelector('#mobile-nav');
menu.addEventListener('click',()=>{const open=menu.getAttribute('aria-expanded')==='true';menu.setAttribute('aria-expanded',String(!open));menu.setAttribute('aria-label',open?'Open navigation':'Close navigation');mobile.hidden=open});
mobile.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{mobile.hidden=true;menu.setAttribute('aria-expanded','false');menu.setAttribute('aria-label','Open navigation')}));
const track=root.querySelector('#review-track');
const prev=root.querySelector('#reviews-prev');
const next=root.querySelector('#reviews-next');
const escapeHTML=s=>s.replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const updateArrows=()=>{prev.disabled=track.scrollLeft<4;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-4;};
prev.addEventListener('click',()=>track.scrollBy({left:-track.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));
next.addEventListener('click',()=>track.scrollBy({left:track.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));
track.addEventListener('scroll',updateArrows,{passive:true});window.addEventListener('resize',updateArrows);

track.querySelectorAll('.review-play').forEach(button=>button.addEventListener('click',()=>{const player=document.createElement('video');player.className='review-inline-video';player.controls=true;player.playsInline=true;player.preload='metadata';player.src=button.dataset.video;player.poster=button.dataset.poster;player.setAttribute('aria-label',button.getAttribute('aria-label'));const captions=document.createElement('track');captions.kind='captions';captions.src=button.dataset.captions;captions.srclang='en';captions.label='English';player.crossOrigin='anonymous';player.append(captions);button.replaceWith(player);player.focus();player.play().catch(()=>{});}));updateArrows();})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
